module.exports = __webpack_public_path__ + "img/debt3.3a804f5c.jpg";